import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { useContext, useState, useRef, useEffect } from 'react'
import GeneralContext from '../../contexts/GeneralContext'
import { useNavigate } from 'react-router-dom'
import SettingsTab from '../SettingsTab'
import SlidingSettingsTab from './SlidingSettingsTab'
import SlidingLogoutTab from './SlidingLogoutTab'
import LogoutTab from '../LogoutTab'
import './MenuTab.css'
import FriendsTab from '../FriendsTab'

function SlideoutMenu() {
   return (
      <div className="slideout">
         <div className="slideout-tab-area">
            <SlidingSettingsTab />
            <SlidingLogoutTab />
         </div>
      </div>
   )
}

function toggleMenu(status) {
   return status === 'display' ? 'hidden' : 'display'
}

// function useOutsideAlerter(ref) {
//    const {ignorePointer, setIgnorePointer} = useContext(GeneralContext)
//    useEffect(() => {
//       /**
//        * Alert if clicked on outside of element
//        */
//       console.log('ignore pointer is: ', ignorePointer)
//       function handleClickOutside(event) {
//          if (ref.current && !ref.current.contains(event.target)) {
//             console.log('ignore pointer is: ', ignorePointer)
//             if (ignorePointer) {
//                console.log('changing to active')
//                setIgnorePointer(false)
//             }
//          }
//       }
//       // Bind the event listener
//       document.addEventListener('mousedown', handleClickOutside)
//       return () => {
//          // Unbind the event listener on clean up
//          document.removeEventListener('mousedown', handleClickOutside)
//       }
//    }, [ref])
// }

function MenuTab() {
   const {
      setCurrentTab,
      currentTab,
      showFullSize,
      ignorePointer,
      setIgnorePointer,
      hideOptions,
      setHideOptions
   } = useContext(GeneralContext)

   const navigator = useNavigate()
   // const changeScreen = () => {
   //    setCurrentTab("Profile")
   //    navigator('/main/profile')
   // }
   const [showMenu, SetShowMenu] = useState('hidden')
   const wrapperRef = useRef(null)
   // useOutsideAlerter(wrapperRef)

   useEffect(() => {
      function handleClickOutside(event) {
         if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            // alert('You clicked outside of me!')
            setHideOptions(false)
            setIgnorePointer(false)
            SetShowMenu('hidden')
         }
      }

      document.addEventListener('mousedown', handleClickOutside)
      return () => {
         // Unbind the event listener on clean up
         document.removeEventListener('mousedown', handleClickOutside)
      }
   }, [])

   return (
      <div
         className="tab menu-tab"
         onClick={() => {
            if (ignorePointer) {
               console.log('using if')
               setHideOptions(false)
               setIgnorePointer(false)
               SetShowMenu(toggleMenu('display'))

            } else {
               console.log('using else')
               setHideOptions(true)
               setIgnorePointer(true)
               SetShowMenu(toggleMenu('hidden'))
            }
         }}
         ref={wrapperRef}
      >
         <div className={`innerTab`}>
            <div className="iconTab">
               <FontAwesomeIcon icon={faBars} className="iconTab" />
               {showMenu === 'display' ? <SlideoutMenu /> : null}
            </div>
            {showFullSize && <p className="tabText">Menu</p>}
         </div>
      </div>
   )
}
export default MenuTab
